/* tslint:disable */
import { UserResource } from "./UserResource"

export class UserListResource {
		errorCode: number;
		errorMessage: string;

		users: UserResource[];
}
